export const enum PersonalGuaranteeLevelEnum {
  None = 0,
  UpTo20Percent = 1,
  TwentyOneTo35Percent = 2,
  OneHundredPercent = 3,
  ThirtySixTo50Percent = 4,
}
